// Full page loads, behind one object so tests (jsdom cannot navigate) can
// observe them. A recording page is left only through these (see
// replay-document.js): a full page load is the only thing that ends a Hotjar
// recording.
export const pageNavigator = {
  assign: (href) => window.location.assign(href),
  reload: () => window.location.reload(),
};
